import { Controller } from "@hotwired/stimulus"

// Describes what a manager-approved action should submit.
//
// This used to build and submit the form itself, in response to an event
// dispatched at the button that opened the approval. That button does not
// reliably survive: the ops channel refreshes the check whenever the order
// moves, and a morph during the seconds a manager spends typing a PIN replaces
// it — so the event reached a detached node and the approved action was
// dropped without a word.
//
// Now it only answers "what would you send?", while the button is still
// attached and the answer is still readable. manager-approval holds that
// answer as plain data and does the submitting once approved.
export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "POST" }
  }
  // Inputs the action needs to carry beyond the approval token — a comp's
  // reason and quantity, for instance. Each submits under its own `name`, so
  // the markup decides what travels rather than this controller knowing about
  // any particular action.
  static targets = ["param"]

  collect(event) {
    event.detail.submission = {
      url: this.urlValue,
      method: this.methodValue,
      fields: Object.fromEntries(this.paramTargets.map((t) => [t.name, t.value]))
    }
  }
}
